<template>
  <div>
    <b-card title="بدست آوردن اختلاف حساب">
      <div class="row">
        <b-col>
          <b-form-group label="مبلغ مورد نظر">
            <date-picker @change="changeToDate" v-model="date"></date-picker>
          </b-form-group>
        </b-col>
        <b-col></b-col>
        <b-col></b-col>
      </div>
      <div class="row">
        <b-col>
          <b-form-group label="مبلغ مورد نظر">
            <b-form-input v-model="amountTxt"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col></b-col>
        <b-col></b-col>
      </div>
      <div class="row mt-2">
        <b-col>
          <b-button :disabled="disabled" class="btn btn-primary" @click="findIt">
            {{ buttontext }}
          </b-button>
        </b-col>
      </div>

      <b-table :items="equaled" :fields="fields"> </b-table>
    </b-card>
  </div>
</template>
<script>
import moment from "jalali-moment";
import httpHelper from "../../helpers/httpHelper";
export default {
  name: "EkhtelafHesab",
  data() {
    return {
      amountTxt: "0",
      fields: [
        {
          key: "first.transaction_id",
          label: "کد اول",
        },
        {
          key: "first.cost",
          label: "مبلغ",
        },
        {
          key: "first.website_name",
          label: "وبسایت اول",
        },
        {
          key: "first.tracking_number",
          label: "کد رهگیری",
        },
        {
          key: "last.transaction_id",
          label: "کد دوم",
        },
        {
          key: "last.cost",
          label: "مبلغ",
        },
        {
          key: "last.website_name",
          label: "وبسایت مقصد",
        },
        {
          key: "last.tracking_number",
          label: "کد رهگیری",
        },
      ],
      date: "",
      items: [
        {
          id: 1,
          cost: 3,
        },
        {
          id: 2,
          cost: 5,
        },
        {
          id: 3,
          cost: 7,
        },
        {
          id: 4,
          cost: 9,
        },
        {
          id: 5,
          cost: 4,
        },
        {
          id: 6,
          cost: 8,
        },
        {
          id: 7,
          cost: 5,
        },
        {
          id: 8,
          cost: 12,
        },
        {
          id: 9,
          cost: 4,
        },
        {
          id: 10,
          cost: 3,
        },
        {
          id: 11,
          cost: 9,
        },
        {
          id: 12,
          cost: 16,
        },
        {
          id: 13,
          cost: 5,
        },
      ],
      equaled: [],
      disabled: false,
      buttontext: "جستوجو",
    };
  },
  mounted() {
    this.date = moment().format("jYYYY/jMM/jDD");
    this.changeToDate();
  },
  methods: {
    changeToDate() {
      this.buttontext = "دریافت اطلاعات";
      this.disabled = true;
      httpHelper
        .getData(
          "~transaction/transaction/admin/all?mdid12_money_type=483&datefrom=" +
            this.date +
            "&dateto=" +
            this.date +
            "&is_verify=1&isForExcel=true"
        )
        .then((res) => {
          this.buttontext = "جستوجو";
          this.disabled = false;
          this.items = res.result.excel;
        });
    },
    findIt() {
      this.equaled = [];
      var amount = parseInt(this.amountTxt);
      var array = this.items;
      let set = new Set();
      for (var i = 0; i < array.length; i++) {
        for (var j = 0; j < array.length; j++) {
          if (i == j) continue;
          else if (array[i].cost + array[j].cost === amount)
            if (
              !set.has(
                array[i].transaction_id + "-" + array[j].transaction_id
              ) &&
              !set.has(array[j].transaction_id + "-" + array[i].transaction_id)
            ) {
              set.add(array[j].transaction_id + "-" + array[i].transaction_id);
              this.equaled.push({
                first: array[i],
                last: array[j],
              });
            }
        }
      }
    },
  },
};
</script>